module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C2816"
  }, [_c('span', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents ")])]), _vm._v(" "), _c('p', {
    staticClass: "C2817"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/03_List_of#page_vii"
    }
  }, [_vm._v("List of Abbreviations ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2820"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/04_Acknowle#page_ix"
    }
  }, [_vm._v("Acknowledgments ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2817"
  }, [_c('a', {
    attrs: {
      "href": "#/html/05_1_Introd#page_1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("1")]), _vm._v(" "), _c('em', [_vm._v("Introduction ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2817"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_PART_ONE#page_33"
    }
  }, [_vm._v("PART ONE   ")])]), _c('a', {
    attrs: {
      "href": "#/html/06_PART_ONE#page_33"
    }
  }, [_vm._v("Abortion Reforms of the Long 1960s ")])]), _vm._v(" "), _c('p', {
    staticClass: "C2822"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_2_The_Re#page_35"
    }
  }, [_vm._v("2   ")])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/html/07_2_The_Re#page_35"
    }
  }, [_vm._v("The Reforms and Their Roots ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2820"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_3_Medica#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3   ")])]), _c('em', [_c('span', {
    attrs: {
      "href": "#/html/08_3_Medica#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Medical Interests and Priorities ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2817"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_PART_TWO#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO   ")])]), _c('span', {
    attrs: {
      "href": "#/html/09_PART_TWO#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After Reform ")])]), _vm._v(" "), _c('p', {
    staticClass: "C2822"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_4_Aborti#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4   ")])]), _c('em', [_c('span', {
    attrs: {
      "href": "#/html/10_4_Aborti#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abortion Services ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2820"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_5_The_Po#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5   ")])]), _c('em', [_c('span', {
    attrs: {
      "href": "#/html/11_5_The_Po#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Politicization of Abortion ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2820"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_6_Policy#page_166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6   ")])]), _c('em', [_c('span', {
    attrs: {
      "href": "#/html/12_6_Policy#page_166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Policy Change after Reform ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2820"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_7_Politi#page_202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7   ")])]), _c('em', [_c('span', {
    attrs: {
      "href": "#/html/13_7_Politi#page_202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Political Institutions and Abortion Policy ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2817"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/14_Referenc#page_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2820"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/15_Appendix#page_221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: Statements on Abortion in American Party Platforms, 1972–2008 ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2820"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/16_Appendix#page_228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: U.S. Supreme Court Cases on Abortion ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2820"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/17_Appendix#page_231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 3: Abortion Attitudes in the United States and Britain ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2820"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/18_Appendix#page_232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 4: Abortion Funding and Provision in the United States, Britain, and Canada, 1970s–2000s ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2820"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/19_Appendix#page_234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 5: Abortion Attitudes in the United States, Britain, and Canada, 1975–2004 ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2820"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/20_Notes#page_237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C2820"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/21_Index#page_341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b60f1e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/02_Contents.vue
// module id = 63
// module chunks = 0